export const SKIP_AUTH = false;

export const getPostLoginPath = (role) => {
  const normalized = String(role || 'registrar').toLowerCase().replace(/\s+/g, '_');
  if (normalized === 'super_admin') return '/super-admin';
  if (normalized === 'court_admin') return '/admin';
  return '/dashboard';
};
